module.exports = __webpack_public_path__ + "static/media/hire-a-helper.04f89d8c.svg";